export default "__VITE_ASSET__BZQ2OSvK__"